import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import './Menu.scss';

import LogoDev from '../../assets/_images/logo/logo-uninter-DEV.png';
import LogoQA from '../../assets/_images/logo/logo-uninter-qa.png';
import Logo from '../../assets/_images/logo/logo-uninter.png';

import AuthService from '../../services/Auth';
import MenuItem from './MenuItem';
import enviromment from '../../environment';
import { useContainerContext } from '../../contexts/ContainerContext';


function Menu() {
    const { desktopMenuAberto, mobileMenuAberto,
        toggleMobileMenuAberto, toggleDesktopMenu } = useContainerContext();
    const [menuAbertoId, setMenuAberto] = useState(0);

    function toggleListaMenu(menuId) {
        setMenuAberto(menuId === menuAbertoId ? 0 : menuId);
    }

    function handleNavigateHome() {
        toggleDesktopMenu();
        handleNavigate();
    }

    function handleNavigate() {
        if (mobileMenuAberto)
            toggleMobileMenuAberto();
    }

    function redirectExterno(url) {
        window.open(url);
    }

    let menus = AuthService.getMenu();

    let menusExt = [
        montaMenuPagamento(),
        montaMenuContratos()
    ];

    function montaMenuPagamento() {
        let menu =
        {
            codigoReferencia: "pagamentos",
            filhos: [],
            id: 1,
            menuPai: null,
            nome: 'Pagamentos',
            nomeIcone: 'fa fa-file-invoice-dollar',
            privilegios: [],
            url: enviromment.pagamentos,
            visivel: 1
        };
        return menu;
    };

    function montaMenuContratos() {
        let menu =
        {
            codigoReferencia: "contratos",
            filhos: [],
            id: 2,
            menuPai: null,
            nome: 'Contratos',
            nomeIcone: 'fa fa-file-invoice-dollar',
            privilegios: [],
            url: enviromment.contratoDigital,
            visivel: 1
        };
        return menu;
    };


    if (Array.isArray(menus)) {
        menus = menus.sort((a, b) => a.nome > b.nome ? 1 : (a.nome < b.nome ? -1 : 0));
    }

    return (
        <div className="side-left-menu">
            <div className={`menu ${mobileMenuAberto ? 'menu-open-mobile' : ''}`}>
                <div className={`wrapper uninter-menu-base`}>
                    <nav id="sidebar" className={`${!desktopMenuAberto ? 'sidebar-small' : ''}`}>
                        <div className="sidebar-header">
                            <div className="uninter-dark">
                                {
                                    desktopMenuAberto &&
                                    <NavLink to="/" className="navbar-brand ">
                                        <img alt="" src={`${enviromment.ambiente === 'DEV' ? LogoDev : (enviromment.ambiente === 'QA' ? LogoQA : Logo)}`} width="148" height="35" />
                                    </NavLink>
                                }
                            </div>
                        </div>

                        <ul className="list-unstyled components">

                            <li>
                                <NavLink to="/"
                                    className={({ isActive }) => `menu-link tooltip ${isActive ? ' menu-aberto' : ''}`}
                                    onClick={() => setMenuAberto(0)}
                                >
                                    <i className="fa fa-home"></i>
                                    Início
                                </NavLink>
                                <div className={`space`}></div>
                                {
                                    menus
                                        .filter(menu => (menu.visivel || menu.filhos.length > 0) && menu.nome !== 'Início')
                                        .map(menu =>
                                            <MenuItem
                                                key={menu.id}
                                                {...menu}
                                                menuAbertoId={menuAbertoId}
                                                toggleMenu={toggleListaMenu}
                                                navigate={handleNavigate}
                                            />
                                        )
                                }
                                {
                                    /* menus "externos", que fazem somente um redirect simples para uma pagina externa */
                                    menusExt.map(menuExt =>
                                        <NavLink key={menuExt.id} to={"/"} className="menu-link tooltip" onClick={() => redirectExterno(menuExt.url)}>
                                            <i className={menuExt.nomeIcone}></i>
                                            <span>{menuExt.nome}</span>
                                            <div className="tooltiptext-end">{menuExt.nome}</div>
                                        </NavLink>
                                    )
                                }
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            {
                mobileMenuAberto &&
                <div className="menu-overlay" onClick={() => toggleMobileMenuAberto()}></div>
            }
        </div>
    )
}

export default Menu;